// Dashboard.js - VERSÃO COMPLETA COM PARCELAMENTO AUTOMÁTICO

import React, { useState, useEffect, useCallback } from 'react';import axios from './config/axiosConfig';


import { useTheme } from './ThemeContext'; 


function Dashboard({ selectedMonth, selectedYear, onGoBack }) {
  const { theme, toggleTheme } = useTheme();

  const [lancamento, setLancamento] = useState({
    fornecedor: '', contaDesmembrada: 'nao', categoria: '', contaCorrente: '',
    dataCompra: '', valorCompra: '', quantidadeParcelas: '', valorParcela: '',
    parcelaAtual: '', dataVencimento: '', tipoDocumento: '', numeroDocumento: '',
    observacao: '',
  });

  const [fornecedores, setFornecedores] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [listaLancamentos, setListaLancamentos] = useState([]);
  const [lancamentosIA, setLancamentosIA] = useState([]); // Novo estado para lançamentos da IA
  const [contasCorrentes, setContasCorrentes] = useState([]);
  const [filteredLancamentos, setFilteredLancamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editingIAId, setEditingIAId] = useState(null); // Novo estado para edição de lançamentos IA
  const [selectedItems, setSelectedItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  
  const [searchFornecedor, setSearchFornecedor] = useState('');
  const [searchCategoria, setSearchCategoria] = useState('');
  const [showFornecedorDropdown, setShowFornecedorDropdown] = useState(false);
  const [showCategoriaDropdown, setShowCategoriaDropdown] = useState(false);

  const [filters, setFilters] = useState({
    contaCorrente: '',
    fornecedor: '',
    categoria: '',
    dataInicio: '',
    dataFim: ''
  });
  const [showFilters, setShowFilters] = useState(false);

  // Estados para modal de exclusão de parcelas
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteModalData, setDeleteModalData] = useState(null);

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  const monthName = selectedMonth ? monthNames[selectedMonth - 1] : '';

  const formatDateBR = (dateString) => {
    if (!dateString) return '';
    const dateOnly = dateString.split('T')[0];
    const [year, month, day] = dateOnly.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    // Se já está no formato YYYY-MM-DD, retorna
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString;
    }
    // Se tem formato DD/MM/YYYY, converte
    if (dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    // Se tem formato ISO (YYYY-MM-DDTHH:MM:SS), extrai a data
    const dateOnly = dateString.split('T')[0];
    return dateOnly;
  };

  const formatCurrency = (value) => {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

    const calculateTotals = (lancamentos = filteredLancamentos) => {
      // CORREÇÃO: Usar valorParcela se for parcelado (quantidadeParcelas > 0), 
      // ou valorCompra se for à vista.
      const totalMensal = lancamentos.reduce((acc, item) => {
        let valorASomar = 0;
        const isParcelado = parseInt(item.quantidadeParcelas) > 0;

        if (isParcelado) {
          // Se for parcelado, somamos apenas o valor da parcela
          valorASomar = parseFloat(item.valorParcela) || 0;
        } else {
          // Se for à vista, somamos o valor total da compra
          valorASomar = parseFloat(item.valorCompra) || 0;
        }
        return acc + valorASomar;
      }, 0);

      const totalParcelas = lancamentos.reduce((acc, item) => acc + (parseFloat(item.valorParcela) || 0), 0);
      
      // Retornamos o total mensal corrigido.
      return { total: totalMensal, totalParcelas, count: lancamentos.length };
    };

  // 🟢 NOVO: Calcular automaticamente o valor da parcela
  useEffect(() => {
    if (lancamento.valorCompra && lancamento.quantidadeParcelas) {
      const valorCompra = parseFloat(lancamento.valorCompra);
      const quantidade = parseInt(lancamento.quantidadeParcelas);
      
      if (valorCompra > 0 && quantidade > 0) {
        const valorParcela = (valorCompra / quantidade).toFixed(2);
        
        setLancamento(prev => ({
          ...prev,
          valorParcela: valorParcela,
          parcelaAtual: prev.parcelaAtual || '1'
        }));
      }
    } else {
      setLancamento(prev => ({
        ...prev,
        valorParcela: '',
        parcelaAtual: ''
      }));
    }
  }, [lancamento.valorCompra, lancamento.quantidadeParcelas]);

  const applyFilters = useCallback(() => {
    let filtered = [...listaLancamentos];

    if (filters.contaCorrente) {
      filtered = filtered.filter(item => 
        item.contaCorrente && item.contaCorrente.toLowerCase().includes(filters.contaCorrente.toLowerCase())
      );
    }

    if (filters.fornecedor) {
      filtered = filtered.filter(item => 
        item.fornecedor && item.fornecedor.toLowerCase().includes(filters.fornecedor.toLowerCase())
      );
    }

    if (filters.categoria) {
      filtered = filtered.filter(item => 
        item.categoria && item.categoria.toLowerCase().includes(filters.categoria.toLowerCase())
      );
    }

    if (filters.dataInicio) {
      filtered = filtered.filter(item => {
        if (!item.dataCompra) return false;
        const itemDate = new Date(item.dataCompra);
        const startDate = new Date(filters.dataInicio);
        return itemDate >= startDate;
      });
    }

    if (filters.dataFim) {
      filtered = filtered.filter(item => {
        if (!item.dataCompra) return false;
        const itemDate = new Date(item.dataCompra);
        const endDate = new Date(filters.dataFim);
        return itemDate <= endDate;
      });
    }

    setFilteredLancamentos(filtered);
    setSelectedItems([]);
  }, [listaLancamentos, filters]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (selectedMonth && selectedYear) {
        document.title = `AZENHA - Lançamentos de ${monthName}/${selectedYear}`;
      }

      console.log('[Dashboard] Buscando dados da Omie...');

      const [fornecedoresResponse, categoriasResponse, contasCorrentesResponse] = await Promise.all([
        axios.post('/api/omie/fornecedores').catch(err => {
          console.error('[Dashboard] Erro ao buscar fornecedores:', err.response?.data || err.message);
          return { data: [] };
        }),
        axios.post('/api/omie/categorias').catch(err => {
          console.error('[Dashboard] Erro ao buscar categorias:', err.response?.data || err.message);
          return { data: [] };
        }),
        axios.post('/api/omie/contas-correntes').catch(err => {
          console.error('[Dashboard] Erro ao buscar contas correntes:', err.response?.data || err.message);
          return { data: [] };
        })
      ]);

      console.log('[Dashboard] Fornecedores recebidos:', fornecedoresResponse.data?.length || 0);
      console.log('[Dashboard] Categorias recebidas:', categoriasResponse.data?.length || 0);
      console.log('[Dashboard] Contas correntes recebidas:', contasCorrentesResponse.data?.length || 0);

      const filteredFornecedores = (fornecedoresResponse.data || []).filter(cliente =>
        cliente.tags && cliente.tags.some(tag => tag.tag === 'Fornecedor')
      );
      setFornecedores(filteredFornecedores);

      const cleanedCategories = (categoriasResponse.data || []).filter(c =>
        c.descricao && !c.descricao.toLowerCase().includes('disponível')
      );
      setCategorias(cleanedCategories);

      setContasCorrentes(contasCorrentesResponse.data || []);

      const [lancamentosResponse, lancamentosIAResponse] = await Promise.all([
        axios.get(`/api/lancamentos?mes=${selectedMonth}&ano=${selectedYear}`),
        axios.get(`/api/lancamentos/ia?mes=${selectedMonth}&ano=${selectedYear}`)
      ]);

      setListaLancamentos(lancamentosResponse.data);
      setLancamentosIA(lancamentosIAResponse.data);
    } catch (err) {
      setError("Não foi possível carregar os dados. Verifique a conexão com o back-end.");
      console.error("[Dashboard] Erro ao buscar dados:", err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, selectedYear, monthName]);

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchData();
    }
  }, [fetchData, selectedMonth, selectedYear]);

  const filteredFornecedoresList = fornecedores.filter(f => 
    f.razao_social.toLowerCase().includes(searchFornecedor.toLowerCase())
  );
  const filteredCategoriasList = categorias.filter(c => 
    c.descricao.toLowerCase().includes(searchCategoria.toLowerCase())
  );

  const handleSelectFornecedor = (fornecedor) => {
    setLancamento(prev => ({ ...prev, fornecedor }));
    setSearchFornecedor(fornecedor);
    setShowFornecedorDropdown(false);
  };

  const handleSelectCategoria = (categoria) => {
    setLancamento(prev => ({ ...prev, categoria }));
    setSearchCategoria(categoria);
    setShowCategoriaDropdown(false);
  };

  const clearFilters = () => {
    setFilters({
      contaCorrente: '',
      fornecedor: '',
      categoria: '',
      dataInicio: '',
      dataFim: ''
    });
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters).filter(value => value.trim() !== '').length;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-container')) {
        setShowFornecedorDropdown(false);
        setShowCategoriaDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // 🟢 ATUALIZADO: handleChange com validação de parcelas
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'quantidadeParcelas') {
      const quantidade = parseInt(value) || 0;
      
      setLancamento(prevLancamento => {
        const novoLancamento = { 
          ...prevLancamento, 
          [name]: value 
        };
        
        if (quantidade > 0 && !prevLancamento.parcelaAtual) {
          novoLancamento.parcelaAtual = '1';
        }
        
        if (quantidade === 0) {
          novoLancamento.parcelaAtual = '';
          novoLancamento.valorParcela = '';
        }
        
        return novoLancamento;
      });
    } 
    else if (name === 'parcelaAtual') {
      const parcelaAtual = parseInt(value) || 0;
      const quantidadeParcelas = parseInt(lancamento.quantidadeParcelas) || 0;
      
      if (quantidadeParcelas > 0 && parcelaAtual > quantidadeParcelas) {
        alert(`A parcela atual não pode ser maior que a quantidade de parcelas (${quantidadeParcelas})`);
        return;
      }
      
      setLancamento(prevLancamento => ({ ...prevLancamento, [name]: value }));
    }
    else {
      setLancamento(prevLancamento => ({ ...prevLancamento, [name]: value }));
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleLancar = async (e) => {
  e.preventDefault();

  // Validação adicional para parcelas
  const quantidade = parseInt(lancamento.quantidadeParcelas) || 0;
  if (quantidade > 0) {
    const confirmacao = window.confirm(
      `Serão criados ${quantidade - (parseInt(lancamento.parcelaAtual) || 1) + 1} lançamento(s) nos próximos meses.\n\n` +
      `Parcela ${lancamento.parcelaAtual} de ${quantidade} - Valor: ${formatCurrency(lancamento.valorParcela)}\n\n` +
      `Deseja continuar?`
    );

    if (!confirmacao) return;
  }

  const dataToSave = { ...lancamento };
  dataToSave.valorCompra = dataToSave.valorCompra === '' ? null : dataToSave.valorCompra;
  dataToSave.quantidadeParcelas = dataToSave.quantidadeParcelas === '' ? null : dataToSave.quantidadeParcelas;
  dataToSave.valorParcela = dataToSave.valorParcela === '' ? null : dataToSave.valorParcela;
  dataToSave.parcelaAtual = dataToSave.parcelaAtual === '' ? null : dataToSave.parcelaAtual;

  try {
    const token = localStorage.getItem('token');
    const config = { headers: { Authorization: `Bearer ${token}` } };

    const response = await axios.post('/api/lancamentos', dataToSave);

    // Verificar se há avisos de duplicação na mensagem
    const mensagem = response.data.message || '';

    if (quantidade > 0) {
      // Verificar se há parcelas duplicadas
      if (mensagem.includes('já existia')) {
        alert(`⚠️ ATENÇÃO: Lançamento com parcelas duplicadas!\n\n${mensagem}\n\nAlgumas parcelas já existiam no sistema e foram puladas.`);
      } else {
        alert(`✓ ${mensagem}`);
      }
    } else {
      console.log('Lançamento salvo com sucesso!');
      alert('✓ Lançamento criado com sucesso!');
    }

    await fetchData();
    setLancamento({
      fornecedor: '', contaDesmembrada: 'nao', categoria: '', contaCorrente: '',
      dataCompra: '', valorCompra: '', quantidadeParcelas: '', valorParcela: '',
      parcelaAtual: '', dataVencimento: '', tipoDocumento: '', numeroDocumento: '',
      observacao: '',
    });
    setSearchFornecedor('');
    setSearchCategoria('');
    setShowForm(false);
  } catch (error) {
    console.error('Erro ao salvar o lançamento:', error.response?.data?.error || error.message);
    alert('Erro ao salvar o lançamento. Tente novamente.');
  }
};

  const handleUpdate = async (e) => {
    e.preventDefault();
    const dataToUpdate = { ...lancamento };
    const idToUpdate = editingId || editingIAId;
    try {
      const response = await axios.put(`/api/lancamentos/${idToUpdate}`, dataToUpdate);

      await fetchData();

      // Mostrar mensagem de sucesso apropriada
      if (response.data.parcelasAtualizadas && response.data.parcelasAtualizadas > 1) {
        alert(`✓ ${response.data.message}\n\nTodas as parcelas do grupo foram atualizadas e validadas!`);
      } else {
        alert('✓ Lançamento atualizado com sucesso!');
      }

      setEditingId(null);
      setEditingIAId(null);
      setLancamento({
        fornecedor: '', contaDesmembrada: 'nao', categoria: '', contaCorrente: '',
        dataCompra: '', valorCompra: '', quantidadeParcelas: '', valorParcela: '',
        parcelaAtual: '', dataVencimento: '', tipoDocumento: '', numeroDocumento: '',
        observacao: '',
      });
      setSearchFornecedor('');
      setSearchCategoria('');
      setShowForm(false);
    } catch (error) {
      console.error('Erro ao modificar lançamento:', error.response?.data?.error || error.message);
      alert('Erro ao modificar o lançamento. Tente novamente.');
    }
  };
  
  const handleCheckboxChange = (id) => {
    setSelectedItems(prevSelected =>
      prevSelected.includes(id)
        ? prevSelected.filter(item => item !== id)
        : [...prevSelected, id]
    );
  };

  const handleDelete = async () => {
    // Se houver apenas 1 item selecionado, verificar se é parcelado
    if (selectedItems.length === 1) {
      const id = selectedItems[0];
      try {
        // Verificar se o lançamento é parcelado
        const response = await axios.get(`/api/lancamentos/${id}/parcelas-relacionadas`);

        if (response.data.isParcelado) {
          // É parcelado, mostrar modal com opções
          setDeleteModalData({
            id,
            ...response.data,
            isIA: false
          });
          setShowDeleteModal(true);
          return; // Não continuar com a exclusão aqui
        }
      } catch (error) {
        console.error('Erro ao verificar lançamento:', error);
        // Se houver erro na verificação, continua com exclusão normal
      }
    }

    // Exclusão normal (múltiplos itens ou único não parcelado)
    if (window.confirm(`Tem certeza que deseja excluir ${selectedItems.length} lançamento(s)?`)) {
      try {
        await axios.delete('/api/lancamentos', { data: { ids: selectedItems } });
        setListaLancamentos(listaLancamentos.filter(item => !selectedItems.includes(item.id)));
        setSelectedItems([]);
        alert('✓ Lançamento(s) excluído(s) com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir lançamentos:', error.response?.data?.error || error.message);
        alert('Erro ao excluir lançamentos. Tente novamente.');
      }
    }
  };

  const handleEdit = () => {
    if (selectedItems.length === 1) {
      const itemToEdit = listaLancamentos.find(item => item.id === selectedItems[0]);
      setEditingId(itemToEdit.id);
      setLancamento({
        ...itemToEdit,
        dataCompra: formatDateInput(itemToEdit.dataCompra),
        dataVencimento: formatDateInput(itemToEdit.dataVencimento)
      });
      setSearchFornecedor(itemToEdit.fornecedor || '');
      setSearchCategoria(itemToEdit.categoria || '');
      setSelectedItems([]);
      setShowForm(true);
    }
  };

  // Funções para manipular lançamentos da IA
  const handleValidarIA = async (id) => {
    if (window.confirm('Deseja validar este lançamento? Ele será movido para os lançamentos confirmados. Se for parcelado, TODAS as parcelas do grupo serão validadas.')) {
      try {
        const response = await axios.put(`/api/lancamentos/${id}/validar`);

        // Mostrar mensagem de sucesso com quantidade de parcelas
        if (response.data.parcelasValidadas) {
          alert(`✓ ${response.data.message}\nParcelas validadas: ${response.data.parcelas.join(', ')}`);
        } else {
          alert('✓ Lançamento validado com sucesso!');
        }

        // Recarregar os dados para atualizar ambas as tabelas
        fetchData();
        console.log('Lançamento validado com sucesso!');
      } catch (error) {
        console.error('Erro ao validar lançamento:', error.response?.data?.error || error.message);
        alert('Erro ao validar lançamento. Tente novamente.');
      }
    }
  };

  const handleEditIA = (item) => {
    setEditingIAId(item.id);
    setLancamento({
      ...item,
      dataCompra: formatDateInput(item.dataCompra),
      dataVencimento: formatDateInput(item.dataVencimento)
    });
    setSearchFornecedor(item.fornecedor || '');
    setSearchCategoria(item.categoria || '');
    setShowForm(true);
  };

  const handleDeleteIA = async (id) => {
    console.log('[DEBUG] handleDeleteIA chamado com ID:', id);
    try {
      // Verificar se o lançamento é parcelado
      console.log('[DEBUG] Fazendo requisição para verificar parcelas...');
      const response = await axios.get(`/api/lancamentos/${id}/parcelas-relacionadas`);
      console.log('[DEBUG] Resposta recebida:', response.data);

      if (response.data.isParcelado) {
        // É parcelado, mostrar modal com opções
        console.log('[DEBUG] Lançamento é parcelado, abrindo modal...');
        setDeleteModalData({
          id,
          ...response.data,
          isIA: true
        });
        setShowDeleteModal(true);
        console.log('[DEBUG] Modal deveria estar aberto agora');
      } else {
        // Não é parcelado, exclusão normal
        console.log('[DEBUG] Lançamento NÃO é parcelado, confirmação normal');
        if (window.confirm('Tem certeza que deseja excluir este lançamento?')) {
          await axios.delete(`/api/lancamentos/${id}`);
          setLancamentosIA(lancamentosIA.filter(item => item.id !== id));
          console.log('Lançamento excluído com sucesso!');
        }
      }
    } catch (error) {
      console.error('[ERRO] Erro ao verificar lançamento:', error);
      console.error('[ERRO] Detalhes:', error.response?.data || error.message);
      alert(`Erro ao verificar lançamento: ${error.response?.data?.error || error.message}`);
    }
  };

  // Função para confirmar exclusão (apenas uma parcela)
  const handleConfirmDeleteOne = async () => {
    try {
      await axios.delete(`/api/lancamentos/${deleteModalData.id}`);

      if (deleteModalData.isIA) {
        setLancamentosIA(lancamentosIA.filter(item => item.id !== deleteModalData.id));
      } else {
        setListaLancamentos(listaLancamentos.filter(item => item.id !== deleteModalData.id));
        setSelectedItems([]);
      }

      setShowDeleteModal(false);
      setDeleteModalData(null);
      console.log('Lançamento excluído com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir lançamento:', error.response?.data?.error || error.message);
      alert('Erro ao excluir lançamento. Tente novamente.');
    }
  };

  // Função para confirmar exclusão (todas as parcelas do grupo)
  const handleConfirmDeleteAll = async () => {
    try {
      const response = await axios.delete(`/api/lancamentos/${deleteModalData.id}/excluir-grupo`);

      if (deleteModalData.isIA) {
        // Recarregar dados da IA
        fetchData();
      } else {
        // Recarregar dados confirmados
        fetchData();
      }

      setShowDeleteModal(false);
      setDeleteModalData(null);
      alert(response.data.message);
    } catch (error) {
      console.error('Erro ao excluir parcelas:', error.response?.data?.error || error.message);
      alert('Erro ao excluir parcelas. Tente novamente.');
    }
  };

  const handleDownload = async () => {
    try {
      window.open('/api/lancamentos/download', '_blank');
      console.log('Download iniciado. Verifique o seu navegador.');
    } catch (error) {
      console.error('Erro ao iniciar o download:', error);
    }
  };

  const totals = calculateTotals();
  
  return (
    <div className="dashboard-container">
      <main className="main-container">
        <div className="dashboard-title-bar">
          <button onClick={onGoBack} className="back-button">
            ← Voltar
          </button>
          <div className="title-and-totals">
            <h2>Lançamentos de {monthName} de {selectedYear}</h2>
            <div className="totals-summary">
              <span className="total-item">Total: {formatCurrency(totals.total)}</span>
              <span className="total-item">Registros: {totals.count}</span>
            </div>
          </div>
          
          <button onClick={toggleTheme} className="theme-toggle-btn">
            {theme === 'light' ? '🌙 Modo Escuro' : '☀️ Modo Claro'}
          </button>
        </div>
        
        <div className="action-bar">
          <div className="action-group">
            <button 
              className="btn btn-primary"
              onClick={() => {
                setShowForm(!showForm);
                setEditingId(null);
                setLancamento({
                  fornecedor: '', contaDesmembrada: 'nao', categoria: '', contaCorrente: '',
                  dataCompra: '', valorCompra: '', quantidadeParcelas: '', valorParcela: '',
                  parcelaAtual: '', dataVencimento: '', tipoDocumento: '', numeroDocumento: '',
                  observacao: '',
                });
                setSearchFornecedor('');
                setSearchCategoria('');
              }}
            >
              <span className="btn-icon">+</span>
              <span className="btn-text">Novo</span>
            </button>

            <button 
              className={`btn btn-secondary ${getActiveFiltersCount() > 0 ? 'has-filters' : ''}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <span className="btn-icon">🔍</span>
              <span className="btn-text">Filtros</span>
              {getActiveFiltersCount() > 0 && (
                <span className="filter-badge">{getActiveFiltersCount()}</span>
              )}
            </button>
          </div>
          
          <div className="action-group">
            {selectedItems.length > 0 && (
              <>
                {selectedItems.length === 1 && (
                  <button className="btn btn-secondary" onClick={handleEdit}>
                    <span className="btn-icon">✏️</span>
                    <span className="btn-text-mobile">Editar</span>
                  </button>
                )}
                <button className="btn btn-danger" onClick={handleDelete}>
                  <span className="btn-icon">🗑️</span>
                  <span className="btn-text-mobile">Excluir ({selectedItems.length})</span>
                </button>
              </>
            )}
            <button className="btn btn-outline" onClick={handleDownload}>
              <span className="btn-icon">📥</span>
              <span className="btn-text-mobile">Excel</span>
            </button>
          </div>
        </div>

        {error && (
          <div className="alert alert-error">
            <span>⚠️ {error}</span>
          </div>
        )}

        {showFilters && (
          <div className="filter-panel">
            <div className="filter-header">
              <h3>Filtrar Lançamentos</h3>
              <button 
                className="close-btn"
                onClick={() => setShowFilters(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="filter-grid">
              <div className="filter-group">
                <label>Conta Corrente</label>
                <select 
                  name="contaCorrente" 
                  value={filters.contaCorrente} 
                  onChange={handleFilterChange}
                >
                  <option value="">Todas as contas</option>
                  {contasCorrentes.map(conta => (
                    <option key={conta.codigo} value={conta.descricao}>
                      {conta.descricao}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Fornecedor</label>
                <select
                  name="fornecedor"
                  value={filters.fornecedor}
                  onChange={handleFilterChange}
                >
                  <option value="">Todos os fornecedores</option>
                  {fornecedores.map(f => (
                    <option key={f.codigo_cliente_omie} value={f.razao_social}>
                      {f.razao_social}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Categoria</label>
                <select
                  name="categoria"
                  value={filters.categoria}
                  onChange={handleFilterChange}
                >
                  <option value="">Todas as categorias</option>
                  {categorias.map(c => (
                    <option key={c.codigo} value={c.descricao}>
                      {c.descricao}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Data Início</label>
                <input
                  type="date"
                  name="dataInicio"
                  value={filters.dataInicio}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-group">
                <label>Data Fim</label>
                <input
                  type="date"
                  name="dataFim"
                  value={filters.dataFim}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-actions">
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={clearFilters}
                >
                  Limpar Filtros
                </button>
              </div>
            </div>
          </div>
        )}
        
        {showForm && (
          <div className="form-card">
            <div className="form-header">
              <h2>{editingId ? "Editar Lançamento" : "Novo Lançamento"}</h2>
              <button 
                className="close-btn"
                onClick={() => setShowForm(false)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={(editingId || editingIAId) ? handleUpdate : handleLancar} className="form-body">
              <div className="form-grid">
                <div className="form-group dropdown-container">
                  <label>Fornecedor *</label>
                  <input
                    type="text"
                    value={searchFornecedor}
                    onChange={(e) => {
                      setSearchFornecedor(e.target.value);
                      setLancamento(prev => ({ ...prev, fornecedor: e.target.value }));
                      setShowFornecedorDropdown(true);
                    }}
                    onFocus={() => setShowFornecedorDropdown(true)}
                    placeholder={loading ? "Carregando..." : "Digite para buscar fornecedor..."}
                    required
                    autoComplete="off"
                  />
                  {showFornecedorDropdown && !loading && (
                    <div className="dropdown-list">
                      {filteredFornecedoresList.length === 0 ? (
                        <div className="dropdown-item-empty">Nenhum fornecedor encontrado</div>
                      ) : (
                        <>
                          <div className="dropdown-header">
                            {filteredFornecedoresList.length} fornecedor(es) encontrado(s)
                          </div>
                          {filteredFornecedoresList.slice(0, 30).map(f => (
                            <div
                              key={f.codigo_cliente_omie}
                              className="dropdown-item"
                              onClick={() => handleSelectFornecedor(f.razao_social)}
                            >
                              {f.razao_social}
                            </div>
                          ))}
                          {filteredFornecedoresList.length > 30 && (
                            <div className="dropdown-footer">
                              Continue digitando para refinar a busca...
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group dropdown-container">
                  <label>Categoria *</label>
                  <input
                    type="text"
                    value={searchCategoria}
                    onChange={(e) => {
                      setSearchCategoria(e.target.value);
                      setLancamento(prev => ({ ...prev, categoria: e.target.value }));
                      setShowCategoriaDropdown(true);
                    }}
                    onFocus={() => setShowCategoriaDropdown(true)}
                    placeholder={loading ? "Carregando..." : "Digite para buscar categoria..."}
                    required
                    autoComplete="off"
                  />
                  {showCategoriaDropdown && !loading && (
                    <div className="dropdown-list">
                      {filteredCategoriasList.length === 0 ? (
                        <div className="dropdown-item-empty">Nenhuma categoria encontrada</div>
                      ) : (
                        <>
                          <div className="dropdown-header">
                            {filteredCategoriasList.length} categoria(s) encontrada(s)
                          </div>
                          {filteredCategoriasList.slice(0, 30).map(c => (
                            <div
                              key={c.codigo}
                              className="dropdown-item"
                              onClick={() => handleSelectCategoria(c.descricao)}
                            >
                              {c.descricao}
                            </div>
                          ))}
                          {filteredCategoriasList.length > 30 && (
                            <div className="dropdown-footer">
                              Continue digitando para refinar a busca...
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Conta Corrente *</label>
                  <select name="contaCorrente" value={lancamento.contaCorrente} onChange={handleChange} required>
                    <option value="">Selecione...</option>
                    {contasCorrentes.map(conta => (
                      <option key={conta.codigo} value={conta.descricao}>
                        {conta.descricao}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Data da Compra *</label>
                  <input type="date" name="dataCompra" value={lancamento.dataCompra} onChange={handleChange} required />
                </div>

                <div className="form-group">
                  <label>Valor da Compra *</label>
                  <input 
                    type="number" 
                    step="0.01"
                    name="valorCompra" 
                    value={lancamento.valorCompra} 
                    onChange={handleChange} 
                    placeholder="0.00"
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Conta Desmembrada</label>
                  <select name="contaDesmembrada" value={lancamento.contaDesmembrada} onChange={handleChange}>
                    <option value="nao">Não</option>
                    <option value="sim">Sim</option>
                  </select>
                </div>

                {/* 🟢 NOVA SEÇÃO DE PARCELAS COM CÁLCULO AUTOMÁTICO */}
                <div className="form-group">
                  <label>Quantidade de Parcelas</label>
                  <input 
                    type="number" 
                    name="quantidadeParcelas" 
                    value={lancamento.quantidadeParcelas} 
                    onChange={handleChange}
                    min="0"
                    placeholder="0 = À vista"
                  />
                  <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '4px', display: 'block' }}>
                    Deixe 0 ou vazio para pagamento à vista
                  </small>
                </div>

                <div className="form-group">
                  <label>Valor da Parcela</label>
                  <input 
                    type="number" 
                    step="0.01"
                    name="valorParcela" 
                    value={lancamento.valorParcela} 
                    onChange={handleChange} 
                    placeholder="Calculado automaticamente"
                    readOnly={lancamento.quantidadeParcelas > 0}
                    style={{ 
                      backgroundColor: lancamento.quantidadeParcelas > 0 ? '#f5f5f5' : 'white',
                      cursor: lancamento.quantidadeParcelas > 0 ? 'not-allowed' : 'text'
                    }}
                  />
                  {lancamento.quantidadeParcelas > 0 && lancamento.valorParcela && (
                    <small style={{ color: '#28a745', fontSize: '0.85rem', marginTop: '4px', display: 'block' }}>
                      ✓ {formatCurrency(lancamento.valorParcela)} × {lancamento.quantidadeParcelas} = {formatCurrency(lancamento.valorCompra)}
                    </small>
                  )}
                </div>

                <div className="form-group">
                  <label>Parcela Atual</label>
                  <input 
                    type="number" 
                    name="parcelaAtual" 
                    value={lancamento.parcelaAtual} 
                    onChange={handleChange}
                    min="1"
                    max={lancamento.quantidadeParcelas || 999}
                    disabled={!lancamento.quantidadeParcelas || lancamento.quantidadeParcelas == 0}
                    style={{ 
                      backgroundColor: (!lancamento.quantidadeParcelas || lancamento.quantidadeParcelas == 0) ? '#f5f5f5' : 'white',
                      cursor: (!lancamento.quantidadeParcelas || lancamento.quantidadeParcelas == 0) ? 'not-allowed' : 'text'
                    }}
                  />
                  {lancamento.quantidadeParcelas > 0 && lancamento.parcelaAtual && (
                    <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '4px', display: 'block' }}>
                      {lancamento.quantidadeParcelas - lancamento.parcelaAtual + 1} parcela(s) será(ão) criada(s)
                    </small>
                  )}
                </div>

                <div className="form-group">
                  <label>Data de Vencimento</label>
                  <input type="date" name="dataVencimento" value={lancamento.dataVencimento} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Tipo de Documento</label>
                  <input type="text" name="tipoDocumento" value={lancamento.tipoDocumento} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Número do Documento</label>
                  <input type="text" name="numeroDocumento" value={lancamento.numeroDocumento} onChange={handleChange} />
                </div>

                <div className="form-group form-group-full">
                  <label>Observação</label>
                  <textarea name="observacao" value={lancamento.observacao} onChange={handleChange} rows="3"></textarea>
                </div>
              </div>

              <div className="form-actions">
                <button type="button" className="btn btn-cancel" onClick={() => setShowForm(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-save">
                  {editingId ? "Salvar Alterações" : "Adicionar Lançamento"}
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="table-card">
          <div className="table-header">
            <h2>Lançamentos Registrados</h2>
            <span className="table-count">{filteredLancamentos.length} registros</span>
          </div>

          {loading ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Carregando dados...</p>
            </div>
          ) : (
            <>
              {filteredLancamentos.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">📊</div>
                  <h3>
                    {listaLancamentos.length === 0 
                      ? "Nenhum lançamento registrado"
                      : "Nenhum lançamento encontrado com os filtros aplicados"
                    }
                  </h3>
                  <p>
                    {listaLancamentos.length === 0 
                      ? "Comece adicionando seu primeiro lançamento"
                      : "Tente ajustar os filtros para encontrar os lançamentos desejados"
                    }
                  </p>
                  {listaLancamentos.length > 0 && (
                    <button 
                      className="btn btn-secondary"
                      onClick={clearFilters}
                      style={{ marginTop: '1rem' }}
                    >
                      Limpar Filtros
                    </button>
                  )}
                </div>
              ) : (
                <div className="table-wrapper">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th></th> 
                        <th>Fornecedor</th>
                        <th>Categoria</th>
                        <th>Valor Total</th>
                        <th>Data Compra</th>
                        <th>Parcelas</th>
                        <th>Valor Parcela</th>
                        <th>Vencimento</th>
                        <th>Documento</th>
                        <th>Observação</th>
                        <th>Conta Corrente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLancamentos.map(item => (
                        <tr key={item.id} className={selectedItems.includes(item.id) ? 'selected' : ''}>
                          <td>
                            <input 
                              type="checkbox" 
                              checked={selectedItems.includes(item.id)} 
                              onChange={() => handleCheckboxChange(item.id)} 
                            />
                          </td>
                          <td className="td-primary">{item.fornecedor}</td>
                          <td>{item.categoria}</td>
                          <td className="td-currency">{formatCurrency(item.valorCompra)}</td>
                          <td>{formatDateBR(item.dataCompra)}</td>
                          <td className="td-center">
                            {item.quantidadeParcelas ? `${item.parcelaAtual || '1'}/${item.quantidadeParcelas}` : '-'}
                          </td>
                          <td className="td-currency">{item.valorParcela ? formatCurrency(item.valorParcela) : '-'}</td>
                          <td>{formatDateBR(item.dataVencimento)}</td>
                          <td>{item.tipoDocumento || '-'} {item.numeroDocumento || ''}</td>
                          <td className="td-obs">{item.observacao || '-'}</td>
                          <td>{item.contaCorrente || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>

        {/* Tabela de Lançamentos Sugeridos pela IA - CARD SEPARADO */}
        {!loading && lancamentosIA.length > 0 && !showFilters && (
          <div className="table-card ia-card">
            <div className="table-header ia-header">
              <div className="ia-header-content">
                <span className="ia-badge">IA</span>
                <h2>Lançamentos Sugeridos por IA</h2>
              </div>
              <span className="table-count ia-count">{lancamentosIA.length} sugestões</span>
            </div>

            <div className="ia-description">
              <p>Revise, edite ou valide os lançamentos sugeridos pela Inteligência Artificial antes de incluí-los nos registros oficiais.</p>
            </div>

            <div className="table-wrapper">
              <table className="data-table ia-table">
                <thead>
                  <tr>
                    <th>Fornecedor</th>
                    <th>Categoria</th>
                    <th>Valor</th>
                    <th>Data Compra</th>
                    <th>Vencimento</th>
                    <th>Observação</th>
                    <th className="td-actions">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {lancamentosIA.map(item => (
                    <tr key={item.id} className="ia-row">
                      <td className="td-primary">{item.fornecedor}</td>
                      <td>{item.categoria}</td>
                      <td className="td-currency">{formatCurrency(item.valorCompra)}</td>
                      <td>{formatDateBR(item.dataCompra)}</td>
                      <td>{formatDateBR(item.dataVencimento)}</td>
                      <td className="td-obs">{item.observacao || '-'}</td>
                      <td className="td-actions">
                        <div className="ia-action-buttons">
                          <button
                            className="ia-btn ia-btn-validate"
                            onClick={() => handleValidarIA(item.id)}
                            title="Validar lançamento"
                          >
                            ✓
                          </button>
                          <button
                            className="ia-btn ia-btn-edit"
                            onClick={() => handleEditIA(item)}
                            title="Editar lançamento"
                          >
                            ✎
                          </button>
                          <button
                            className="ia-btn ia-btn-delete"
                            onClick={() => handleDeleteIA(item.id)}
                            title="Excluir lançamento"
                          >
                            ✕
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Modal de confirmação para exclusão de parcelas */}
        {showDeleteModal && deleteModalData && (
          <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>⚠️ Lançamento Parcelado</h2>
                <button
                  className="modal-close"
                  onClick={() => setShowDeleteModal(false)}
                >
                  ✕
                </button>
              </div>

              <div className="modal-body">
                <p className="modal-info">
                  Este é um lançamento parcelado:
                </p>
                <div className="modal-lancamento-info">
                  <p><strong>Fornecedor:</strong> {deleteModalData.lancamento?.fornecedor || 'N/A'}</p>
                  <p><strong>Valor Total:</strong> R$ {(Number(deleteModalData.lancamento?.valorCompra) || 0).toFixed(2)}</p>
                  <p><strong>Parcela Atual:</strong> {deleteModalData.lancamento?.parcelaAtual || 'N/A'} de {deleteModalData.lancamento?.quantidadeParcelas || 'N/A'}</p>
                  <p><strong>Total de Parcelas:</strong> {deleteModalData.totalParcelas || 0} parcela(s) cadastrada(s)</p>
                </div>

                <p className="modal-question">
                  O que você deseja excluir?
                </p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleConfirmDeleteOne}
                >
                  Excluir Apenas Esta Parcela
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleConfirmDeleteAll}
                >
                  Excluir Todas as {deleteModalData.totalParcelas} Parcelas
                </button>
                <button
                  className="btn btn-light"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Dashboard;